<template>

  <div>

<PageNotFound></PageNotFound>


  </div>

</template>
<script>

import PageNotFound from "@/views/PageNotFound.vue";

export default {

  name: 'Tariff',
  data() {
    return {
      username: "",
      reg_end: false,
    }
  },
  components: {PageNotFound},

  mounted: function () {

  },
  methods: {}
}
</script>


<style scoped lang="scss">

</style>

